/**
 * /admin/catalogs — Backoffice CRM, вкладка «Справочники».
 *
 * Демонстрация: один компонент — universal editor для всех 37 каталогов.
 * Никаких хардкодов. Добавится новый caталог → появится здесь автоматически.
 */

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { CatalogBrowser } from '../components/admin/CatalogBrowser';
import { CatalogEditor } from '../components/admin/CatalogEditor';
import type { CatalogRegistration } from '@apartsales/shared';

export const Route = createFileRoute('/admin/catalogs')({
  component: AdminCatalogsPage,
});

function AdminCatalogsPage() {
  const [selected, setSelected] = useState<CatalogRegistration | null>(null);

  return (
    <div className="min-h-screen bg-[var(--color-page-bg)] pb-12">
      <div className="max-w-4xl mx-auto px-4 pt-6">
        {selected ? (
          <CatalogEditor catalog={selected} onBack={() => setSelected(null)} />
        ) : (
          <CatalogBrowser onSelect={setSelected} />
        )}
      </div>
    </div>
  );
}
